module.exports = __webpack_public_path__ + "static/infovisual-f0acb80bf23ae534511ed87024242d5c.png";